import { connectGreeksFessMetricsTabContent } from './GreeksFeesMetricsTabContent.connect';
import { GreeksFeesMetricsTabContentPresentation } from './GreeksFeesMetricsTabContentPresentation';

export const GreeksFeesMetricsTabContent = connectGreeksFessMetricsTabContent(GreeksFeesMetricsTabContentPresentation);
